<app-badge>
  <mat-icon class="channel-icon">wifi_channel</mat-icon>
  <ng-container *ngIf="slug$ | async; else all">
    {{ 'reports.channel' | translate: { channel: channel$ | async } }}
  </ng-container>
  <ng-template #all>
    {{ 'reports.all_channels' | translate }}
  </ng-template>
</app-badge>
